"use strict";
module.exports = require('../../module.compiled').vendored['contexts'].HeadManagerContext;

//# sourceMappingURL=head-manager-context.js.map